import NetworkError from "../http/networkError";
import { ErrorType } from "../http/types";

export default class CommercialNetworkError extends NetworkError {
  public id;
  public code;

  /**
   * Constructs a Commercial network error.
   *
   * @param message The error message.
   * @param status The network call response status.
   * @param id The commercial backend internal error id.
   * @param code The commercial backend internal error code.
   */
  constructor(message: string, status: number, id: string, code: string) {
    super(message, status);
    this.id = id;
    this.code = code;
    this.type = ErrorType.COMMERCIAL_BACKEND;
    if (
      "captureStackTrace" in Error &&
      typeof Error.captureStackTrace === "function"
    ) {
      Error.captureStackTrace(this, CommercialNetworkError);
    } else if (Object.prototype.hasOwnProperty.call(Error, "stack")) {
      this.stack = new Error().stack;
    }
  }
}
